// WordPress REST returns titles/excerpts as entity-encoded HTML. These helpers
// turn them into plain text for <title>/<meta> (never for innerHTML).
const ENTITIES: Record<string, string> = {
  '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#039;': "'", '&#39;': "'",
  '&nbsp;': ' ', '&hellip;': '…', '&#8211;': '–', '&#8212;': '—', '&#8216;': '‘',
  '&#8217;': '’', '&#8220;': '“', '&#8221;': '”', '&#8230;': '…',
};

export function decodeEntities(s: string): string {
  return s
    .replace(/&(?:amp|lt|gt|quot|nbsp|hellip|#0?39|#82(?:1[12]|1[67]|2[01]|30));/g, (m) => ENTITIES[m] ?? m)
    .replace(/&#(\d+);/g, (_, n: string) => String.fromCodePoint(Number(n)));
}

/** Strip tags, decode entities, collapse whitespace, optionally truncate on a word. */
export function toPlainText(html: string, max?: number): string {
  const text = decodeEntities(html.replace(/<[^>]*>/g, ' ')).replace(/\s+/g, ' ').trim();
  if (!max || text.length <= max) return text;
  return `${text.slice(0, text.lastIndexOf(' ', max - 1) > 0 ? text.lastIndexOf(' ', max - 1) : max - 1)}…`;
}
